export default {
  GET_ALL: `#graphql
  query getGiftMessages($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getGiftMessages(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        order,
        phone,
        name,
        title,
        message,
        from,
        _id,
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  UPDATE: `#graphql
  mutation UpdateGiftMessage($order: String!, $giftMessageUpdate: GiftMessageUpdateInput!) {
    updateGiftMessage(order: $order, giftMessageUpdate: $giftMessageUpdate)
    {
      order
    }            
  }`,

  DELETE: `#graphql
  mutation DeleteGiftMessage($order: String!) {
    deleteGiftMessage(order: $order)
    {
      order
    }            
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/giftMessage.js